export const userConstants = {
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  LOGOUT: 'USERS_LOGOUT',

  WHO_AM_I_LOADED: 'WHO_AM_I_LOADED'
};



// WEBPACK FOOTER //
// ./src/_constants/user.constants.js